module.exports = __webpack_public_path__ + "static/media/content-04-m.1914789f.png";